import React from 'react';
import { 
  Scale as Balance, 
  BarChart3, 
  Zap, 
  Heart, 
  Target, 
  RotateCcw, 
  CheckCircle, 
  BookOpen,
  User
} from 'lucide-react';

interface ProfileIconProps {
  iconName: string;
  className?: string;
}

export const ProfileIcon: React.FC<ProfileIconProps> = ({ iconName, className = "w-8 h-8" }) => {
  const iconMap = {
    Balance,
    BarChart3,
    Zap,
    Heart,
    Target,
    RotateCcw,
    CheckCircle,
    BookOpen,
    User
  };

  const IconComponent = iconMap[iconName as keyof typeof iconMap] || User;

  return <IconComponent className={className} />;
};